module.exports = __webpack_public_path__ + "static/media/print.8ca39317.svg";